<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-form @submit.prevent="salvaMembro">
              <v-card class="login" flat style="border-radius: 16px;padding: 10px;box-shadow: 0 12px 32px rgba(0, 37, 62, 0.18);">
                <span class="login-title">
                  <img :src="igreja.logoUrl" width="230px">
                </span>
                <v-card-text style="padding: 0px">
                  <v-container fluid grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 lg12>
                        <p style="margin-bottom: 0px;font-family: 'Fraunces', serif;font-size: 20px;color: #00253E;">Preencha seus dados:</p>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense
                          hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')"
                          data-vv-name="cpf" type="tel" v-model="membro.cpf" @change="consultaCPF"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg8>
                        <v-text-field light v-model="membro.nome" label="NOME COMPLETO*" single-line outlined
                          color="#00695C" dense hide-details required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>
                        <v-text-field type="tel" light v-model="membro.dataNascimento" label="DATA DE NASCIMENTO*"
                          single-line outlined color="#00695C" required v-mask="'##/##/####'" dense hide-details
                          :error-messages="errors.collect('dateOfBirth')" return-masked-value mask="##/##/####"
                          data-vv-name="dateOfBirth" @blur="carregaRedesPorIdade"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>
                        <v-select outlined dense v-model="membro.sexo" :items="sexo" hide-details item-text="titulo"
                          item-value="id" color="#00695C" label="SEXO*"></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>
                        <v-text-field light label="WHATSAPP COM DDD*" color="#00695C" type="tel" outlined hide-details
                          v-mask="'(##) #####-####'" dense required v-model="membro.telefone"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg3>
                        <v-select outlined dense v-model="membro.estadoCivil" :items="estadoCivil" hide-details
                          item-text="titulo" item-value="id" color="#00695C" label="ESTADO CIVIL*"></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-select outlined dense v-model="membro.batizado" :items="condicoes" hide-details
                          item-text="text" item-value="value" color="#00695C" label="VOCÊ É BATIZADO?*"></v-select>
                      </v-flex>
                      <v-flex v-if="membro.batizado" xs12 sm12 lg4>
                        <v-select outlined dense v-model="membro.batismoLiberdade" :items="condicoes" hide-details
                          item-text="text" item-value="value" color="#00695C"
                          label="FOI BATIZADO NA IGREJA BATISTA DA LIBERDADE?*"></v-select>
                      </v-flex>
                      <v-flex v-if="membro.batizado && membro.batismoLiberdade == false" xs12 sm12 lg4>
                        <v-text-field outlined dense v-model="membro.igrejaBatismo" hide-details color="#00695C"
                          label="INFORME O NOME DA IGREJA*"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-select outlined dense v-model="membro.tipoIntegracao" :items="tipoIntegracao" hide-details
                          item-text="titulo" item-value="id" color="#00695C" label="TIPO DE INTEGRAÇÃO*"></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg4>
                        <v-text-field type="tel" light v-model="membro.dataIntegracao" label="DATA DE INTEGRAÇÃO*"
                          single-line outlined color="#00695C" required v-mask="'##/##/####'" dense hide-details
                          :error-messages="errors.collect('dateOfBirth')" data-vv-name="dateOfBirth"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg6 v-if="mostrarRedesECelulas">
                        <v-select outlined dense v-model="redeSelecionada" :items="redes" hide-details item-text="nome"
                          item-value="id" color="#00695C" label="REDE*" @input="carregaCelulas"></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg6 v-if="mostrarRedesECelulas">
                        <v-select outlined dense :disabled="redeSelecionada == ''" v-model="membro.celulaId"
                          :items="celulas" hide-details item-text="nome" item-value="id" color="#00695C"
                          label="CÉLULA*"></v-select>
                      </v-flex>

                      <v-flex xs12 sm12 lg12>
                        <v-alert type="info" text dense class="mt-2 mb-2">
                          Caso deseje informar os serviços profissionais que você pode oferecer, informe-os abaixo.
                          Assim, outros membros da igreja terão acesso aos seus serviços.
                        </v-alert>
                      </v-flex>

                      <v-flex xs12 sm12 lg12>
                        <p style="margin-bottom: 0px;">Serviços que você pode oferecer:</p>
                      </v-flex>
                      <v-flex xs9 sm9 lg10>
                        <v-autocomplete outlined dense v-model="servicoSelecionado" :items="servicos" hide-details
                          item-text="nome" item-value="codigo" color="#00695C" label="Adicionar Serviço"
                          @input="searchInput = null" :search-input.sync="searchInput"
                          @keydown.enter.prevent="adicionaItensProfissional" @click.stop></v-autocomplete>
                      </v-flex>
                      <v-flex xs3 sm3 lg2>
                        <v-btn block color="success" @click.prevent="adicionaItensProfissional"
                          :disabled="!servicoSelecionado">Add</v-btn>
                      </v-flex>

                      <v-flex xs12 sm12 lg12 v-if="membro.servicos && membro.servicos.length > 0">
                        <v-data-iterator :items="membro.servicos" :items-per-page.sync="iterador.itensPorPagina"
                          hide-default-footer>
                          <template v-slot:no-data></template>

                          <template v-slot:default="props">
                            <v-row dense>
                              <v-col v-for="item in props.items" :key="item" cols="12">
                                <v-card outlined>
                                  <v-list dense style="padding: 0px">
                                    <v-list-item>
                                      <v-list-item-content style="padding: 0px">
                                        <v-list-item-title>{{ nomeProfissao(item) }}</v-list-item-title>
                                      </v-list-item-content>
                                      <v-list-item-action>
                                        <v-list-item-subtitle>
                                          <v-btn icon @click.prevent="removeServicoProfissional(item)">
                                            <v-icon>delete</v-icon>
                                          </v-btn>
                                        </v-list-item-subtitle>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </v-list>
                                </v-card>
                              </v-col>
                            </v-row>
                          </template>
                        </v-data-iterator>
                      </v-flex>

                      <v-flex xs12 sm12 lg12>
                        <v-checkbox v-model="membro.aceiteLgpd" style="margin-top: 10px">
                          <template v-slot:label>
                            <div>
                              Concordo com as <a target="_blank"
                                href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf"
                                @click.stop>políticas de privacidade e tratamento de dados pessoais</a>
                            </div>
                          </template>
                        </v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions style="padding: 0px">
                  <v-container fluid grid-list-md>
                    <v-layout row wrap justify-center>
                      <v-flex xs12 sm12 lg6>
                        <v-btn dark depressed block color="#00695C" rounded style="border-radius: 28px;" large
                          type="submit">Confirmar
                          Cadastro</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-form>

          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoTemplusIntelite.png" width="300px">
          </a>
        </div>

        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card>
            <v-card-title>Informação</v-card-title>
            <v-card-text style="padding: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="texto" style="color:#00695C">Cadastro efetuado com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import axios from 'axios'

export default {
  components: { Snackbar, Loading },
  name: 'RecadastroMembroPage',
  computed: {
    ...mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    nomeMembro() {
      if (this.membro.nome) return this.membro.nome.split(' ')[0];
      return '';
    }
  },
  data() {
    return {
      idIgreja: '6390de5538a3bc18300a2022',
      membro: {
        id: null,
        nome: '',
        cpf: '',
        email: '',
        dataNascimento: '',
        estadoCivil: '',
        sexo: '',
        telefone: '',
        tipo: 'MEMBRO',
        dataIntegracao: '',
        tipoIntegracao: '',
        aceiteLgpd: false,
        celulaId: '',
        igrejaId: '',
        batizado: null,
        igrejaBatismo: '',
        batismoLiberdade: null,
        servicos: [],
        recadastramento: true,
      },
      dialog: false,
      redeSelecionada: '',
      sexo: ['MASCULINO', 'FEMININO'],
      estadoCivil: ['SOLTEIRO(A)', 'CASADO(A)', 'VIÚVO(A)', 'DIVORCIADO(A)', 'RELAÇÃO ESTÁVEL'],
      tipoIntegracao: ['ATRAVÉS DE BATISMO', 'VENHO DE OUTRA IGREJA'],
      condicoes: [
        { value: true, text: 'SIM' },
        { value: false, text: 'NÃO' },
      ],
      redes: [],
      celulas: [],
      isLoading: false,
      fullPage: true,
      igreja: {},
      servicos: [],
      servicoSelecionado: '',
      searchInput: null,
      iterador: {
        itensPorPagina: -1,
      },
      existeProfissional: false,
      profissionalId: null,
      mostrarRedesECelulas: false,
    };
  },

  async mounted() {
    await this.carregaDados();
    await this.carregaProfissoes();
  },

  watch: {
    'membro.cpf'(newCpf, oldCpf) {
      if (newCpf && newCpf.length === 14 && newCpf !== oldCpf) {
        this.consultaCPF();
      } else if (!newCpf || newCpf.length < 14) {
        this.limpaCamposMembroEClearServicos();
      }
    },
    'membro.batizado'() {
      this.atualizaTipoMembro();
    },
    'membro.batismoLiberdade'() {
      this.atualizaTipoMembro();
    },
    'membro.dataNascimento'(newDataNascimento) {
      // Verifica se a data de nascimento está completa (DD/MM/AAAA)
      const isDateComplete = newDataNascimento && newDataNascimento.length === 10 && moment(newDataNascimento, 'DD/MM/YYYY').isValid();

      if (isDateComplete) {
        this.mostrarRedesECelulas = true; // Mostra os campos
        this.carregaRedesPorIdade();
      } else {
        this.redes = [];
        this.redeSelecionada = '';
        this.celulas = [];
        this.membro.celulaId = '';
        this.mostrarRedesECelulas = false; // Esconde os campos
      }
    }
  },

  methods: {
    atualizaTipoMembro() {
      if (this.membro.batizado && this.membro.batismoLiberdade === true) {
        this.membro.tipo = 'MEMBRO';
      } else {
        this.membro.tipo = 'CONGREGADO';
      }
    },
    limpaCamposMembroEClearServicos() {
      const currentCpf = this.membro.cpf;
      const currentRecadastramento = this.membro.recadastramento;

      this.membro = {
        id: null,
        nome: '',
        cpf: currentCpf,
        email: '',
        dataNascimento: '',
        estadoCivil: '',
        sexo: '',
        telefone: '',
        tipo: 'MEMBRO',
        dataIntegracao: '',
        tipoIntegracao: '',
        aceiteLgpd: false,
        celulaId: '',
        igrejaId: '',
        batizado: null,
        igrejaBatismo: '',
        batismoLiberdade: null,
        servicos: [],
        recadastramento: currentRecadastramento,
      };

      this.redeSelecionada = '';
      this.celulas = [];
      this.existeProfissional = false;
      this.profissionalId = null;
      this.redes = [];
      this.membro.celulaId = '';
      this.mostrarRedesECelulas = false; // Garante que estejam escondidos ao limpar
    },

    async carregaDados() {
      this.isLoading = true;
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.idIgreja } });
        if (response.data) {
          this.igreja = response.data;
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#FF5252', 'Erro ao carregar dados da igreja.', 'ERRO');
      } finally {
        this.isLoading = false;
      }
    },

    async carregaRedesPorIdade() {
      if (!this.membro.dataNascimento || this.membro.dataNascimento.length !== 10 || !moment(this.membro.dataNascimento, 'DD/MM/YYYY').isValid()) {
        this.redes = [];
        this.redeSelecionada = '';
        this.celulas = [];
        this.membro.celulaId = '';
        this.mostrarRedesECelulas = false;
        return;
      }

      const dataNascimentoMoment = moment(this.membro.dataNascimento, 'DD/MM/YYYY');
      const idade = moment().diff(dataNascimentoMoment, 'years');
      let tipoRede = '';

      if (idade <= 12) {
        tipoRede = 'KIDS';
      } else {
        tipoRede = 'ADULTO';
      }

      if (!this.igreja.id) {
        this.redes = [];
        this.redeSelecionada = '';
        this.celulas = [];
        this.membro.celulaId = '';
        this.mostrarRedesECelulas = false;
        return;
      }

      try {
        const response = await axios.post(baseApiUrl + 'Redes/listarPublicasPorTipo', {
          igrejaId: this.igreja.id,
          tipo: tipoRede,
        });
        if (response.data) {
          this.redes = response.data;
          const redeAindaExiste = this.redes.some(rede => rede.id === this.redeSelecionada);
          if (!redeAindaExiste) {
            this.redeSelecionada = '';
            this.celulas = [];
            this.membro.celulaId = '';
          }
          this.mostrarRedesECelulas = true;
        } else {
          this.redes = [];
          this.redeSelecionada = '';
          this.celulas = [];
          this.membro.celulaId = '';
          this.mostrarRedesECelulas = false;
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao carregar redes.', 'DESCULPE');
        this.redes = [];
        this.redeSelecionada = '';
        this.celulas = [];
        this.membro.celulaId = '';
        this.mostrarRedesECelulas = false;
      }
    },

    async carregaCelulas() {
      if (!this.redeSelecionada) {
        this.celulas = [];
        return;
      }
      try {
        const response = await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } });
        if (response.data) {
          this.celulas = response.data;
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao consultar Celulas.", "DESCULPE");

      }
    },

    async consultaCPF() {
      this.isLoading = true;
      const tempCpf = this.membro.cpf;
      this.limpaCamposMembroEClearServicos();
      this.membro.cpf = tempCpf;
      this.membro.tipo = 'MEMBRO';
      this.membro.recadastramento = true;

      try {
        const memberResponse = await axios.post(baseApiUrl + 'Membros/buscaPublicaRecadastroCpf', null, { params: { cpf: this.membro.cpf } });
        if (memberResponse.data && memberResponse.data.id) {
          const membroExistente = memberResponse.data;

          this.membro.id = membroExistente.id;
          this.membro.nome = membroExistente.nome;
          this.membro.email = membroExistente.email;
          this.membro.dataNascimento = membroExistente.dataNascimento || '';
          this.membro.estadoCivil = membroExistente.estadoCivil;
          this.membro.sexo = membroExistente.sexo;
          this.membro.telefone = membroExistente.telefone;
          this.membro.dataIntegracao = membroExistente.dataIntegracao ? moment(membroExistente.dataIntegracao).format('DD/MM/YYYY') : '';
          this.membro.tipoIntegracao = membroExistente.tipoIntegracao;
          this.membro.aceiteLgpd = membroExistente.aceiteLgpd;
          this.membro.celulaId = membroExistente.celulaId;
          this.membro.igrejaId = membroExistente.igrejaId;
          this.membro.batizado = membroExistente.batizado;
          this.membro.igrejaBatismo = membroExistente.igrejaBatismo;
          this.membro.batismoLiberdade = membroExistente.batismoLiberdade;
          this.membro.recadastramento = true;

          this.atualizaTipoMembro();

          const isDateComplete = this.membro.dataNascimento && this.membro.dataNascimento.length === 10 && moment(this.membro.dataNascimento, 'DD/MM/YYYY').isValid();
          if (isDateComplete) {
            this.mostrarRedesECelulas = true;
            await this.carregaRedesPorIdade();
          } else {
            this.redes = [];
            this.redeSelecionada = '';
            this.celulas = [];
            this.membro.celulaId = '';
            this.mostrarRedesECelulas = false;
          }

          if (membroExistente.redeId) {
            this.redeSelecionada = membroExistente.redeId;
            await this.carregaCelulas();
            this.membro.celulaId = membroExistente.celulaId;
          } else if (membroExistente.celula && membroExistente.celula.redeId) {
            this.redeSelecionada = membroExistente.celula.redeId;
            await this.carregaCelulas();
            this.membro.celulaId = membroExistente.celulaId;
          } else {
            this.redeSelecionada = '';
            this.celulas = [];
            this.membro.celulaId = '';
          }

          await this.verificaProfissional(membroExistente.id);
        } else {
          this.membro.id = null;
          this.redes = [];
          this.redeSelecionada = '';
          this.celulas = [];
          this.membro.celulaId = '';
          this.mostrarRedesECelulas = false;
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao consultar CPF.", "DESCULPE");
      } finally {
        this.isLoading = false;
      }
    },

    async verificaProfissional(membroId) {
      try {
        const response = await axios.post(baseApiUrl + 'Profissionais/buscarPorMembroPublico', {
          membroId: membroId
        });
        if (response.data.length > 0) {
          this.membro.servicos = response.data[0].servicos || [];
          this.existeProfissional = true;
          this.profissionalId = response.data[0].id;
        } else {
          this.membro.servicos = [];
          this.existeProfissional = false;
          this.profissionalId = null;
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao consultar Profissionais.", "DESCULPE");
      }
    },

    async carregaProfissoes() {
      try {
        const response = await axios.post(baseApiUrl + 'ServicoProfissionals/listarPublicos', {
          igrejaId: this.idIgreja
        });
        if (response.data.length > 0) {
          this.servicos = response.data;
        } else {
          this.servicos = [];
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao consultar Servicos.", "DESCULPE");

      }
    },

    adicionaItensProfissional() {
      if (!this.servicoSelecionado) {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Selecione um serviço para adicionar!', 'ATENÇÃO');
        return;
      }
      if (!this.membro.servicos.includes(this.servicoSelecionado)) {
        this.membro.servicos.push(this.servicoSelecionado);
        this.servicoSelecionado = '';
        this.$refs.chamaSnackbar.snack("#4CAF50", "Serviço adicionado!", "Sucesso");
      } else {
        this.$refs.chamaSnackbar.snack('#F9A825', 'Este serviço já está na lista.', 'ATENÇÃO');
      }
    },

    removeServicoProfissional(itemToRemove) {
      this.membro.servicos = this.membro.servicos.filter(servicoCodigo => servicoCodigo !== itemToRemove);
      this.$refs.chamaSnackbar.snack("#4CAF50", "Serviço removido.", "Sucesso");
    },

    nomeProfissao(codigoProfissao) {
      if (!this.servicos || this.servicos.length === 0) {
        return 'Carregando Serviços...';
      }
      const servico = this.servicos.find(s => s.codigo === codigoProfissao);
      return servico ? servico.nome.trim() : 'Serviço desconhecido';
    },

    async salvaMembro() {
      const vm = this;
      let camposEmBranco = false;

      const requiredFields = [
        'nome', 'cpf', 'dataNascimento', 'sexo', 'telefone', 'aceiteLgpd',
        'estadoCivil', 'tipoIntegracao', 'dataIntegracao'
      ];

      for (const field of requiredFields) {
        if (!this.membro[field] && (this.membro.tipo === 'MEMBRO' || (this.membro.batizado && this.membro.batismoLiberdade === true))) {
          camposEmBranco = true;
          break;
        }
      }

      // Validação específica para data de nascimento completa
      if (!this.membro.dataNascimento || this.membro.dataNascimento.length !== 10 || !moment(this.membro.dataNascimento, 'DD/MM/YYYY').isValid()) {
        camposEmBranco = true;
      }

      // Validação condicional para Rede e Célula se estiverem visíveis
      if (this.mostrarRedesECelulas) {
        if (!this.redeSelecionada) {
          camposEmBranco = true;
        }
        if (!this.membro.celulaId) {
          camposEmBranco = true;
        }
      }


      if (!CpfValidate(this.membro.cpf)) {
        camposEmBranco = true;
      }
      if (!this.membro.aceiteLgpd) {
        camposEmBranco = true;
      }
      if (this.membro.batizado === null) {
        camposEmBranco = true;
      }
      if (this.membro.batizado && this.membro.batismoLiberdade === null) {
        camposEmBranco = true;
      }
      if (this.membro.batizado && this.membro.batismoLiberdade === false && !this.membro.igrejaBatismo) {
        camposEmBranco = true;
      }


      if (camposEmBranco) {
        vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente!", "ATENÇÃO");
        return;
      }

      this.isLoading = true;

      const dataMembroParaEnvio = { ...this.membro };

      if (dataMembroParaEnvio.dataIntegracao) {
        const [day, month, year] = dataMembroParaEnvio.dataIntegracao.split('/');
        dataMembroParaEnvio.dataIntegracao = `${year}-${month}-${day}T00:00:00.000Z`;
      } else {
        dataMembroParaEnvio.dataIntegracao = moment().format('YYYY-MM-DD') + 'T00:00:00.000Z';
      }

      dataMembroParaEnvio.igrejaId = this.igreja.id;

      try {
        const memberResponse = await axios.post(`${baseApiUrl}Membros/salvarPublico`, dataMembroParaEnvio);

        const memberId = memberResponse.data.id;


        const profissionalData = {
          id: this.profissionalId,
          membroId: memberId,
          igrejaId: this.igreja.id,
          servicos: this.membro.servicos
        };

        if (this.membro.servicos && this.membro.servicos.length > 0) {
          await axios.post(`${baseApiUrl}Profissionais/salvarPublico`, profissionalData);
        } else if (this.existeProfissional && this.profissionalId) {
          await axios.post(`${baseApiUrl}Profissionais/excluirPublico`, {
            profissionalId: this.profissionalId,
            membroId: memberId,
          });
        }

        this.dialog = true;
      } catch (error) {
        let errorMessage = "Problema ao realizar operação. Verifique os dados e tente novamente.";
        if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
          errorMessage = error.response.data.error.message;
        }
        this.$refs.chamaSnackbar.snack("#EF5350", errorMessage, "DESCULPE");
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDatePadrao(date) {
      if (!date) return null
      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },
    formatDateBrz(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateHora(date) {
      if (!date) return null
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

    closeDialog() {
      this.dialog = false;
      this.limpaCamposMembroEClearServicos();
    },

    nomeCelula(celulaId) {
      if (!this.celulas || this.celulas.length === 0) {
        return 'Carregando Células...';
      }
      const celula = this.celulas.find(c => c.id === celulaId);
      return celula ? celula.nome.trim() : 'Célula não encontrada';
    },
  },
};
</script>

<style scoped>
/* LOGIN */
.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(135deg, #5BC1A3 0%, #01B094 52%, #00695C 100%);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

@import '../../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css'
</style>
